import { Injectable } from '@angular/core';
import { Viewer } from '../models/viewer';
import { customModdle } from '@ispm/shared/bpmn-io/pathways-meta-data-model';
import { getExtensionModule } from '../bpmn/provider-extension-module';
import { Store } from '@ngrx/store';
import { State } from '../store';
import { BPMN_RENDERER, TEXT_RENDERER, TEXT_RENDERER_FOR_IE11 } from '@ispm/shared/bpmn-io/bpmn-viewer-styling';
import { IEService } from '@ispm/shared/services/IE.service';

@Injectable()
export class BpmnViewerService {

  viewer: Viewer;

  constructor(private store$: Store<State>,
              private ieService: IEService) {
  }

  initBpmnViewer(): void {
    const additionalModulesList = getExtensionModule(this.store$);
    const options = {
      container: '#js-canvas',
      width: '100%',
      height: '100%',
      additionalModules: [additionalModulesList],
      moddleExtensions: {
        pw: customModdle
      },
    };
    if (this.ieService.isIE()) {
      Object.assign(options, BPMN_RENDERER, TEXT_RENDERER_FOR_IE11);
    } else {
      Object.assign(options, BPMN_RENDERER, TEXT_RENDERER);
    }
    this.viewer = new Viewer(options);
  }

  getBpmnViewer() {
    if (this.viewer == null) {
      this.initBpmnViewer();
    }
    return this.viewer;
  }

  public deleteViewer() {
    delete this.viewer;
  }

}




